import React, { useState } from 'react'
import './Home.css';
import Header from '../../components/Header/Header';
import Navbar from '../../components/Navbar/Navbar';
import Exploremenu from '../../components/Exploremenu/Exploremenu';
import Fooddisplay from '../../components/Fooddisplay/Fooddisplay';
import Footer from '../../components/Footer/Footer';
import AppDownload from '../../components/AppDownload/AppDownload';
import Login from '../../components/Login/Login';
function Home() {
  const [category,setCategory]=useState("All");
  const [showLogin,setShowLogin]=useState(false)
  return (
    <div>
        {showLogin && <Login setShowLogin={setShowLogin}/>}
        <Navbar setShowLogin={setShowLogin}/>
        <Header/>
        <Exploremenu category={category} setCategory={setCategory}/>
        <Fooddisplay category={category}/>
        <AppDownload/>
        <Footer/>
    </div>
  )
}

export default Home